import { defineMessages } from 'react-intl';

export default defineMessages({
    hidePackageCoverages: {
        id: 'policy.common.component.policy-marine-info.hide policy details',
        defaultMessage: 'Hide Policy Details'
    },
    showPackageCoverages: {
        id: 'policy.common.component.policy-marine-info.show policy details',
        defaultMessage: 'Show Policy Details'
    },
    mooredLoc: {
        "id": "policy.common.component.policy-marine-info.Moored Loc",
        "defaultMessage": "Moored Location"
    },
    boatType: {
        "id": "policy.common.component.policy-marine-info.Vessel Type",
        "defaultMessage": "Vessel Type"
    },
    motorType: {
        "id": "policy.common.component.policy-marine-info.Motor Type",
        "defaultMessage": "Motor Type"
    },
    yearBuilt: {
        "id": "policy.common.component.policy-marine-info.Year Built",
        "defaultMessage": "Year Built"
    },
    motorDetails: {
        "id": "policy.common.component.policy-marine-info.Trailer, Dingy and Aux Motor Details",
        "defaultMessage": "Trailer, Dingy and Aux Motor Details"
    },
    vin: {
        "id": "policy.common.component.policy-marine-info.VIN",
        "defaultMessage": "Serial/vin"
    },
    value: {
        "id": "policy.common.component.policy-marine-info.Value",
        "defaultMessage": "Value"
    },
    operatorDetail: {
        "id": "policy.common.component.policy-marine-info.Operator name",
        "defaultMessage": "Operator name"
    },
    percentageUsage: {
        "id": "policy.common.component.policy-marine-info.Percentage Usage",
        "defaultMessage": "Percentage Usage"
    },
    vesselName:{
        "id": "policy.common.component.policy-marine-info.Vessel Name",
        "defaultMessage": "Vessel Name"
    },
    registeredOwner: {
        "id": "policy.common.component.policy-marine-info.Registered Owner",
        "defaultMessage": "Registered Owner"
    },
    serialNumber: {
        "id": "policy.common.component.policy-marine-info.Serial Number",
        "defaultMessage": "Serial Number"
    },
    make: {
        "id": "policy.common.component.policy-marine-info.make",
        "defaultMessage": "Make"
    },
    model: {
        "id": "policy.common.component.policy-marine-info.model",
        "defaultMessage": "Model"
    },
    motorValue: {
        "id": "policy.common.component.policy-marine-info.Motor Value",
        "defaultMessage": "Motor Value"
    },
    motorMake: {
        "id": "policy.common.component.policy-marine-info.Motor Make",
        "defaultMessage": "Motor Make"
    },
    motorSerial: {
        "id": "policy.common.component.policy-marine-info.Motor Serial",
        "defaultMessage": "Motor Serial"
    },
    HP: {
        "id": "policy.common.component.policy-marine-info.HP",
        "defaultMessage": "HP"
    },
    fuelType: {
        "id": "policy.common.component.policy-marine-info.Fuel Type",
        "defaultMessage": "Fuel Type"
    },
    motorYearBuilt: {
        "id": "policy.common.component.policy-marine-info.Motor Year Built",
        "defaultMessage": "Motor Year Built"
    },
    maxSpeed: {
        "id": "policy.common.component.policy-marine-info.Max Speed(MPH)",
        "defaultMessage": "Max Speed(MPH)"
    }

});
